// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Ezee","title":"InfoRow_title__2U0Lh"};